// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__duIg2","truncatedText":"styles_truncatedText__ARSI6","fullText":"styles_fullText__2zI_Z","textContainer":"styles_textContainer___sRVe"};